
import { useQuery } from "@tanstack/react-query";
import { getReportsQuickStats } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useQuickStats(options = {}) {
  const { onSuccess, onError, enabled = true, period = "24h" } = options;

  const {
    data,
    error,
    isLoading,
    refetch: reload,
  } = useQuery({
    queryKey: ["reportsQuickStats", period],
    queryFn: async () => {
      try {
        const response = await getReportsQuickStats({ period });
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
  });

  const stats = data?.data?.stats
    ? data.data.stats.filter((item) => item.key !== "success_rate")
    : [];

  const generatedAt = data?.meta?.generated_at
    ? new Date(data.meta.generated_at).toLocaleDateString("en-EG")
    : null;

  return {
    stats,
    generatedAt,
    error,
    isLoading,
    reload,
    period,
  };
}



























































